import Image from "next/image";

import type { FeatureComparison } from "@/content/comparisons/schema";

interface FeatureComparisonSectionProps {
  comparisons: FeatureComparison[];
  competitorName: string;
}

export function FeatureComparisonSection({ comparisons, competitorName }: FeatureComparisonSectionProps) {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="mx-auto max-w-4xl px-6">
        <h2 className="mb-12 font-clash text-3xl font-medium leading-tight tracking-snug text-ash-900 md:text-5xl">
          Detailed Feature Comparison
        </h2>

        <div className="space-y-16">
          {comparisons.map((comparison) => (
            <div key={comparison.title} className="space-y-6">
              <h3 className="font-clash text-xl font-medium leading-tight tracking-[-0.01em] text-ash-900 md:text-2xl">
                {comparison.title}
              </h3>

              <div className="text-base leading-relaxed text-ash-500 md:text-lg">
                <p>
                  <strong className="text-ash-900">{competitorName}</strong> {comparison.competitorDescription}
                </p>
                <p className="mt-4">
                  <strong className="text-rebolt-500">Rebolt</strong> {comparison.reboltDescription}
                </p>
              </div>

              <div className="rounded-xl border border-rebolt-200 bg-rebolt-100/50 px-5 py-4">
                <p className="text-base">
                  <strong className="text-ash-900">Winner: </strong>
                  <strong className="text-rebolt-500">{comparison.winner}</strong>
                  <br />
                  <span className="text-ash-600">{comparison.winnerExplanation}</span>
                </p>
              </div>

              {comparison.images.length > 0 && (
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  {comparison.images.map((img) => (
                    <div key={img.alt} className="overflow-hidden rounded-2xl border border-ash-200">
                      <Image src={img.src} alt={img.alt} width={600} height={400} className="h-auto w-full" />
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
